var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.25C12.4142 20.25 12.75 20.5858 12.75 21L12.75 27.1893L14.4697 25.4697C14.7626 25.1768 15.2374 25.1768 15.5303 25.4697C15.8232 25.7626 15.8232 26.2374 15.5303 26.5303L12.5303 29.5303C12.2374 29.8232 11.7626 29.8232 11.4697 29.5303L8.46967 26.5303C8.17678 26.2374 8.17678 25.7626 8.46967 25.4697C8.76256 25.1768 9.23744 25.1768 9.53033 25.4697L11.25 27.1893L11.25 21C11.25 20.5858 11.5858 20.25 12 20.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.75C11.5858 16.75 11.25 16.4142 11.25 16L11.25 9.81066L9.53033 11.5303C9.23744 11.8232 8.76256 11.8232 8.46967 11.5303C8.17678 11.2374 8.17678 10.7626 8.46967 10.4697L11.4697 7.46967C11.7626 7.17678 12.2374 7.17678 12.5303 7.46967L15.5303 10.4697C15.8232 10.7626 15.8232 11.2374 15.5303 11.5303C15.2374 11.8232 14.7626 11.8232 14.4697 11.5303L12.75 9.81066L12.75 16C12.75 16.4142 12.4142 16.75 12 16.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDown);
export default "/Frontend/static/media/arrow-up-down.ae95029661aa4b8c9fc78d90760a33e2.svg";
export { ForwardRef as ReactComponent };